"use strict";
var asap = require("asap");
var global = require("global");
var document = global.document;

var soundMap = {};

function Sound(fileName, basePath, onError) {
	this._sound = getSound(fileName, basePath);
	if (onError) asap(onError);
}

Sound.web = "audiotags";

Sound.prototype = {
	_sound: null,
	play: play,
	pause: pause,
	stop: pause,
	setVolume: setVolume,
	setCurrentTime: setCurrentTime,
	isLoaded: isLoaded,
};

// TODO: Put URL that makes sense here
Sound.MAIN_BUNDLE = process.env.PUBLIC_URL;

module.exports = Sound;

function getSound(fileName, basePath) {
	var key = Array.isArray(fileName) ? (
		fileName.map(function (name) {
			return basePath + name;
		})
	) : (
		basePath + fileName
	);

	if (!(key in soundMap))
		soundMap[key] = createSound(key);

	return soundMap[key];
}

function createSound(file) {
	var sound = document.createElement("audio");
	sound.id = "sound-" + file;
	sound.preload = "auto";

	if (Array.isArray(file)) {
		file.map(function (source) {
			var sourceElement = document.createElement("source");
			sourceElement.src = source;
			sound.appendChild(sourceElement);
		});
	} else {
		sound.src = file;
	}

	document.body.appendChild(sound);

	return sound;
}

function play(cb) {
	var sound = this._sound;

	sound.play();
	if (cb)
		sound.addEventListener("ended", onEnded);

	return this;

	function onEnded() {
		cb();
		sound.removeEventListener("ended", onEnded);
	}
}

function pause() {
	var sound = this._sound;

	try {
		sound.pause();
	} catch (e) {
		console.error("Sound Error", e);
	}

	return this;
}

function setVolume(volume) {
	var sound = this._sound;

	try {
		if (!volume) {
			sound.muted = true;
			sound.volume = 0;
		} else {
			sound.muted = false;
			sound.volume = volume;
		}
	} catch (e) {
		console.error("Sound Error", e);
	}

	return this;
}


function setCurrentTime(time) {
	var sound = this._sound;

	try {
		sound.currentTime = time;
	} catch (e) {
		console.error("Sound Error", e);
	}

	return this;
}

function isLoaded() {
	return this._sound.readyState !== 0;
}